import { tap } from 'rxjs/operators';
import { AppLoaderService } from './../services/app-loader/app-loader.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class ApiLoaderInterceptor implements HttpInterceptor {

  constructor(private loader: AppLoaderService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // this.loader.start();
    return next.handle(request).pipe(tap(event => {
      if (event instanceof HttpResponse) {
        // this.loader.close();
      }
    }, error => {
      // this.loader.close();
    }));
  }
}
